module.exports = __webpack_public_path__ + "static/media/patient_friendly.53bcf644.png";